import { render, staticRenderFns } from "./CollegeTable.vue?vue&type=template&id=99855732&scoped=true&"
import script from "./CollegeTable.vue?vue&type=script&lang=js&"
export * from "./CollegeTable.vue?vue&type=script&lang=js&"
import style0 from "./CollegeTable.vue?vue&type=style&index=0&id=99855732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99855732",
  null
  
)

export default component.exports